import React, { type FC, type ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { getFamilyContentCategory } from 'reactApp/modules/familyContent/familyContent.selectors';
import { FamilyContentCategoryType } from 'reactApp/modules/familyContent/familyContent.types';
import { FamilySubscription } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/FamilySubscription';
import { SharedAlbums } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedAlbums';
import { SharedBusiness } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedBusiness';
import { SharedFolders } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedFolders';
import { SharedMemories } from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmptyCards/SharedMemories';

import styles from './FamilyContentEmpty.css';

const SHARED_MAP: Record<FamilyContentCategoryType, FC> = {
    [FamilyContentCategoryType.albums]: () => {
        return (
            <>
                <SharedAlbums />
                <SharedMemories />
            </>
        );
    },
    [FamilyContentCategoryType.folders]: () => {
        return (
            <>
                <SharedFolders />
                <SharedBusiness />
            </>
        );
    },
};

export const FamilyContentEmpty = (): ReactElement => {
    const type: FamilyContentCategoryType = useSelector(getFamilyContentCategory);
    const Shared = SHARED_MAP[type];
    return (
        <div className={styles.root} data-qa-id="family-empty">
            <div className={styles.list}>
                <Shared />
                <FamilySubscription />
            </div>
        </div>
    );
};
